<template>
    <div>
        <div class="title">
            <typo name="body-17-bold"> Taux </typo>
        </div>
        <div class="rates-container">
            <search-panorama-rate-value v-model="ratesFilters.rateValue" />
            <search-panorama-rate-unit
                v-model="ratesFilters.rateUnit"
                :annotationOptions="annotationOptions"
            />
        </div>
        <div class="title">
            <typo name="body-17-bold"> Repartition </typo>
        </div>
        <search-panorama-value-comparison
            label="Repartition employé"
            v-model="ratesFilters.rateDistributionEmployer"
            :annotationOptions="annotationOptions"
        />
        <search-panorama-value-comparison
            label="Repartition Salarié"
            v-model="ratesFilters.rateDistributionEmployee"
            :annotationOptions="annotationOptions"
        />
    </div>
</template>

<script>
import { EventBus } from "src/bus/eventBus";
import Typo from "src/components/common/typo/Typo.vue";
import SearchPanoramaRateUnit from "./SearchPanoramaRateUnit.vue";
import SearchPanoramaRateValue from "./SearchPanoramaRateValue.vue";
import SearchPanoramaValueComparison from "./SearchPanoramaValueComparison.vue";

export default {
    props: ["value", "annotationOptions"],
    components: {
        Typo,
        SearchPanoramaRateUnit,
        SearchPanoramaRateValue,
        SearchPanoramaValueComparison,
    },
    data() {
        return {
            ratesFilters: {
                rateValue: this.value.rateValue,
                rateUnit: this.value.rateUnit,
                rateDistributionEmployer: this.value.rateDistributionEmployer,
                rateDistributionEmployee: this.value.rateDistributionEmployee,
            },
        };
    },
    mounted() {
        EventBus.$on("clearPanoramaFilters", () => {
            this.ratesFilters = {
                rateValue: null,
                rateUnit: null,
                rateDistributionEmployer: null,
                rateDistributionEmployee: null,
            };
        });
    },
    watch: {
        ratesFilters: {
            handler(_ratesFilters) {
                this.$emit("input", _ratesFilters);
            },
            deep: true,
        },
    },
};
</script>

<style scoped lang="sass">
.title
    margin: 16px 0

.rates-container
    display: flex
    height: 35px
</style>
